import { FormEvent, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Spinner } from "../components/Loaders";

export function Login() {
  const { firebaseUser, login, loginWithGoogle, refreshProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busyAction, setBusyAction] = useState<"email" | "google" | null>(null);
  const [error, setError] = useState<string | null>(null);
  const from = (location.state as { from?: string } | null)?.from;
  const destination = from && from !== "/app" ? from : "/";

  if (firebaseUser) {
    return <Navigate to={destination} replace />;
  }

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusyAction("email");
    try {
      await login(email.trim(), password);
      await refreshProfile();
      navigate(destination, { replace: true });
    } catch (err) {
      const msg = (err as Error).message || "Sign-in failed";
      setError(msg.replace("Firebase: ", ""));
    } finally {
      setBusyAction(null);
    }
  };

  const onGoogleSignIn = async () => {
    setError(null);
    setBusyAction("google");
    try {
      await loginWithGoogle();
      await refreshProfile();
      navigate(destination, { replace: true });
    } catch (err) {
      const msg = (err as Error).message || "Google sign-in failed";
      setError(msg.replace("Firebase: ", ""));
    } finally {
      setBusyAction(null);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Sign in</h1>
        <p className="sub">Welcome back. Pick up where you left off.</p>
        <form onSubmit={onSubmit}>
          {error && <div className="form-error">{error}</div>}
          <label>
            <span>Email</span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            <span>Password</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button className="primary" type="submit" disabled={busyAction !== null}>
            {busyAction === "email" ? (
              <>
                <Spinner className="button-spinner" />
                Signing in...
              </>
            ) : (
              "Sign in"
            )}
          </button>
          <div className="auth-divider">or</div>
          <button
            className="secondary"
            type="button"
            onClick={onGoogleSignIn}
            disabled={busyAction !== null}
          >
            {busyAction === "google" ? (
              <>
                <Spinner className="button-spinner" />
                Connecting Google...
              </>
            ) : (
              "Continue with Google"
            )}
          </button>
        </form>
        <p className="auth-foot">
          No account yet? <Link to="/register">Create one</Link>
        </p>
      </div>
    </div>
  );
}
